import { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import mainbannerimage from "../../assets/Mainbanner/main.png";
import Modal from "../../components/modal/modal";
import { UserContext } from "../../components/usercontext/user_context";
const WorkerRegister = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate(); // добавили навигацию
  const [modalMessage, setModalMessage] = useState(null);
  const { login } = useContext(UserContext);
  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    email: "",
    password: "",
    tel: "",
    role: "worker", // тут фиксируем роль кандидата
  });

  const [view, setView] = useState(false);

  const handleView = () => {
    setView(!view);
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.repeatpassword) {
      setModalMessage({
        title: t("error"),
        text: t("passwordnomutch"),
        success: false,
        ok: t("ok"),
      });
      return;
    }

    try {
      const response = await fetch("/api/workerregister.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, lang: i18n.language?.slice(0, 2) || "am" }),
      });

      const data = await response.json();

      if (data.success && data.needsEmailVerification) {
        setModalMessage({
          title: t("wellcome"),
          text: t("verify_email_sent"),
          success: true,
          ok: t("ok"),
          onClose: () => navigate("/registerchoose"),
        });
        return;
      }

      if (data.success) {
        localStorage.setItem("userId", data.user.id);
        localStorage.setItem("user", JSON.stringify(data.user));
        login(data.user);
        setModalMessage({
          title: t("wellcome"),
          text: t("registersuccessfuly"),
          success: true,
          ok: t("ok"),
          onClose: () => navigate("/workerprofile"),
        });
        // Проверяем, есть ли отложенный лайк
        const pendingLike = localStorage.getItem("pending_like");
        if (pendingLike) {
          try {
            await fetch("/api/toggle_like.php", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                user_id: data.user.id,
                vacancy_id: parseInt(pendingLike),
              }),
            });
            localStorage.removeItem("pending_like");
          } catch (e) {
            console.error("Ошибка при добавлении отложенного лайка:", e);
          }
        }
      } else {
        setModalMessage({
          title: t("error"),
          text: data.message || t("thisemailusererror"),
          success: false,
          ok: t("ok"),
        });
      }
    } catch (err) {
      console.error("Register error:", err);
      setModalMessage({
        title: t("error"),
        text: t("errortitle"),
        success: false,
        ok: t("ok"),
      });
    }
  };

  return (
    <section
      className="h-screen opacity-0 py-[20px] animate-[showtitle_1s_forwards]"
      style={{
        backgroundImage: `url(${mainbannerimage})`,
      }}
    >
      {/* Модальное окно */}
      {modalMessage && (
        <Modal
          title={modalMessage.title}
          text={modalMessage.text}
          success={modalMessage.success}
          ok={modalMessage.ok}
          onClose={() => {
            if (modalMessage.onClose) modalMessage.onClose();
            setModalMessage(null);
          }}
        />
      )}
      <form
        onSubmit={handleSubmit}
        className="w-[450px] max-sm:w-[90%] h-auto m-[50px_auto] opacity-0 animate-[showtitle_1s_forwards]
       transition-all duration-500 hover:-translate-y-3 flex justify-start items-start flex-col gap-3 max-sm:gap-0
        rounded-2xl bg-white shadow-2xl shadow-black border-[2px]
        border-[#006674]"
      >
        <h1
          className="font-bold tracking-widest bg-[#006674] py-3 rounded-t-xl
       text-white w-full text-center uppercase text-3xl max-sm:text-xl"
        >
          {t("workertitle")}
        </h1>

        <div className="w-full p-5 flex justify-start items-start flex-col gap-1">
          <label htmlFor="name" className="text-[#006674] max-sm:text-sm">
            {t("name")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />

          <label htmlFor="lastName" className="text-[#006674] max-sm:text-sm">
            {t("lastname")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
          />
          <label htmlFor="tel" className="text-[#006674] max-sm:text-sm">
            {t("phone")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type="tel"
            id="tel"
            name="tel"
            value={formData.tel}
            onChange={handleChange}
          />
          <label htmlFor="email" className="text-[#006674] max-sm:text-sm">
            {t("email")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />

          <label htmlFor="password" className="text-[#006674] max-sm:text-sm">
            {t("password")}
          </label>
          <div className="flex w-full justify-between items-center gap-3">
            <input
              className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
              type={view ? "text" : "password"}
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
            <button
              onClick={handleView}
              type="button"
              className="min-w-[40px] min-h-[40px] rounded-full bg-[#006674] text-white"
            >
              {view ? (
                <FontAwesomeIcon icon={faEyeSlash} />
              ) : (
                <FontAwesomeIcon icon={faEye} />
              )}
            </button>
          </div>
          <label
            htmlFor="repeatpassword"
            className="text-[#006674] max-sm:text-sm"
          >
            {t("repeatpassword")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type={view ? "text" : "password"}
            id="repeatpassword"
            name="repeatpassword"
            value={formData.repeatpassword}
            onChange={handleChange}
          />
          <Link
            to="/registerchoose"
            className="text-[#006674] mt-3 transition-all duration-200 hover:text-[#848484]"
          >
            {t("register2")}
          </Link>
          <button
            type="submit"
            className="py-2 capitalize px-4 w-full mt-3 bg-[#006674] text-white rounded-[30px]
          transition-all duration-200 hover:bg-[#848484]"
          >
            {t("register")}
          </button>
        </div>
      </form>
    </section>
  );
};

export default WorkerRegister;
